<template>
	<div class="scrollable only-y">		
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-basket widget-icon accent-text fs-30"></i> {{ $t('menu.products') }}</h2>
		</div>
		<el-dialog :close-on-click-modal="false" title="New Product" :visible.sync="dialogFormVisible" @closed="clear()">
			<el-form :label-position="`left`" ref="form" :model="products" label-width="120px">
				<el-form-item v-if="!hidden" label="Allowed User" :label-width="formLabelWidth">
					<el-input v-model="products.allowedUser" disabled></el-input>
				</el-form-item>

				<el-form-item label="Product Name" :label-width="formLabelWidth">
                    <template>
                        <el-select @change="handleChangeProductName" v-model="products.productName" placeholder="Select">
                            <el-option
                            v-for="item in nameOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>

				<el-form-item v-if="products.productName==='Whatsapp Template Based'" label="Product Type" :label-width="formLabelWidth">
					<template>
						<el-select v-model="products.type" placeholder="Select">
							<el-option
							v-for="item in options3"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>
				</el-form-item>

				<el-form-item label="Product SKU" :label-width="formLabelWidth">
					<el-input v-model="products.productSKU"></el-input>
				</el-form-item>

				<el-form-item label="Product Alias Name" :label-width="formLabelWidth">
					<el-input v-model="products.aliasName"></el-input>
				</el-form-item>

				<el-form-item label="Product Description" :label-width="formLabelWidth">
					<el-input rows="6" type="textarea" v-model="products.description"></el-input>
				</el-form-item>

				<el-form-item v-if="!hidden && products.productName!=='Whatsapp Template Based'" label="Product Type" :label-width="formLabelWidth">
					<template>
						<el-select @change="handleChangeProductType" v-model="products.type" placeholder="Select">
							<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>
				</el-form-item>
				<!-- for type product whatsapp conversation -->
				<el-form-item v-if="hidden" label="Product Type" :label-width="formLabelWidth">
					<template>
						<el-select @change="handleChangeProductType" v-model="products.type" placeholder="Select">
							<el-option
							v-for="item in options2"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>
				</el-form-item>

				<el-form-item v-if="products.type=='notification_caping_plafon' && !hidden" label="Monthly Free Count" :label-width="formLabelWidth">
					<el-input v-model="products.monthly_free_count"></el-input>
				</el-form-item>

				<el-form-item v-if="!hidden && products.productName!=='Whatsapp Template Based'" label="Template HSM" :label-width="formLabelWidth">
					<template>
						<el-select @change="handleChangeProductType" multiple v-model="products.whitelistHsm" placeholder="Select">
							<el-option
							v-for="item in hsm"
							:key="item.id"
							:label="item.name"
							:value="item.name">
							</el-option>
						</el-select>
					</template>
				</el-form-item>

				<el-form-item label="Product Plan" :label-width="formLabelWidth">
					<el-input v-model="products.plan" disabled></el-input>
				</el-form-item>

				<el-form-item v-if="!hidden" label="Product Price" :label-width="formLabelWidth">
					<el-input v-model="products.price"></el-input>
				</el-form-item>

				<el-form-item v-if="!hidden && products.productName!=='Whatsapp Template Based'" label="Product Min. Price" :label-width="formLabelWidth">
					<el-input v-model="products.minPrice"></el-input>
				</el-form-item>

				<el-form-item v-if="hidden" label="Monthly Fee" :label-width="formLabelWidth">
					<el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'monthly')" v-model="products.monthly_fee"></el-input>
				</el-form-item>

				<el-form-item v-if="hidden" label="Product Count" :label-width="formLabelWidth">
					<el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'count')" v-model="products.max_account"></el-input>
				</el-form-item>

				<el-form-item label="PPN (%)" :label-width="formLabelWidth">
					<el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'tax')" v-model="products.tax"></el-input>
				</el-form-item>

				<!-- <el-form-item v-if="hidden && countries.length > 0" label="Allowed Prefix" :label-width="formLabelWidth"> -->
					<!-- <template>
						<el-select :disabled="countries.length == 1" @change="handleChangePrefix" multiple v-model="products.allowedPrefix" filterable placeholder="Select Prefix">
							<el-option
                            v-for="item in countries" :key="item.countryName"
                            :label="item.countryName"
                            :value="item.prefixCode">
                            <div>
                                <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                <span style="font-size: 12px">{{ item.countryName + ` (+${item.prefixCode})` }}</span>
                            </div>
                            </el-option>
						</el-select>
					</template> -->
					<!-- <el-tag
					:key="i"
					v-for="(tag,i) in countries"
					:disable-transitions="false">
					{{tag.countryName}} (+{{tag.prefixCode}})
					</el-tag>
				</el-form-item> -->
				<!-- <el-form-item v-if="hidden && discount" label="Discount" :label-width="formLabelWidth">
					<span v-for="(obj) in products.prefix" :key="obj.code_prefix">
					<el-form v-if="obj.discount" label-width="50px" :model="obj.discount">
						<el-form-item label="CBP">
							<el-row>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-select v-model="obj.discount.type" placeholder="Select Type">
										<el-option
										v-for="(it,i) in discountType"
										:key="i"
										:label="it.label"
										:value="it.value">
										</el-option>
									</el-select>
								</el-col>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'cbp_disc')" v-model="obj.discount.cbp"></el-input>
								</el-col>
								<el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
									<span>{{totalAfterDisc(obj.discount.type, obj.price.cbp,obj.discount.cbp)}}</span>
								</el-col>
							</el-row>
						</el-form-item>
						<el-form-item label="UI">
							<el-row>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-select v-model="obj.discount.type" placeholder="Select Type">
										<el-option
										v-for="(it,i) in discountType"
										:key="i"
										:label="it.label"
										:value="it.value">
										</el-option>
									</el-select>
								</el-col>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'ui_disc')" v-model="obj.discount.ui"></el-input>
								</el-col>
								<el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
									<span>{{totalAfterDisc(obj.discount.type, obj.price.ui,obj.discount.ui)}}</span>
								</el-col>
							</el-row>
						</el-form-item>
						<el-form-item label="BI">
							<el-row>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-select v-model="obj.discount.type" placeholder="Select Type">
										<el-option
										v-for="(it,i) in discountType"
										:key="i"
										:label="it.label"
										:value="it.value">
										</el-option>
									</el-select>
								</el-col>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'bi_disc')" v-model="obj.discount.bi"></el-input>
								</el-col>
								<el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
									<span>{{totalAfterDisc(obj.discount.type, obj.price.bi,obj.discount.bi)}}</span>
								</el-col>
							</el-row>
						</el-form-item>
					</el-form>
					</span>
				</el-form-item> -->
				<!-- <el-form-item v-if="hidden" label="Product Service" :label-width="formLabelWidth">
					<el-form label-width="100px" :model="products.service">
						<el-form-item label="Service Type">
							<el-input disabled v-model="products.service.type"></el-input>
						</el-form-item>
						<div><p><span style="font-weight: bold;">Note: </span>Service Fee x Usage(CBP,BI,UI)</p></div>
						<el-form-item label="Service Fee">
								<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'service')" v-model="products.service.fee" maxlength="2"></el-input>
						</el-form-item>
					</el-form>
				</el-form-item> -->

				<el-form-item v-if="hidden && products.service.type.toLowerCase() == 'percentage'" label="Service Fee (%)" :label-width="formLabelWidth">
					<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'service')" v-model="products.service.fee" maxlength="2"></el-input>
				</el-form-item>

				<el-form-item v-if="hidden && products.service.type.toLowerCase() == 'currency'" label="Service Fee (Currency)" :label-width="formLabelWidth">
					<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'service')" v-model="products.service.fee"></el-input>
				</el-form-item>

				<el-form-item v-if="!hidden && products.productName!=='Whatsapp Template Based'" label="Product Count" :label-width="formLabelWidth">
					<el-input v-model="products.count"></el-input>
				</el-form-item>

				<el-form-item :label-width="formLabelWidth" v-if="products.type.indexOf('tier') != -1 && !hidden" >
					<el-row style="margin-bottom: 10px;">
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>From</span></el-col>
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>To</span></el-col>
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>Price</span></el-col>
					</el-row>
					<el-row v-for="(t, index) in products.tier" :key="index" style="margin-bottom: 10px;">
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
							<el-input v-model="t.from" />
						</el-col>
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
							<el-input v-model="t.to" />
						</el-col>
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
							<el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'price')" v-model="t.price" />
						</el-col>
						<el-col :span="4" :md="4" :sm="4" :xs="4" style="margin-right: 8px">
							<el-button type="text" @click="deleteTier(index)" style="color: red"><i class="mdi mdi-close" /></el-button>
						</el-col>
					</el-row>
					<el-button size="mini" @click="buttonAddTier" type="primary"><i class="mdi mdi-plus"/> Add Tier</el-button>
				</el-form-item>
				<!-- <el-form-item v-if="hidden" label="National Quota" :label-width="formLabelWidth">
					<el-row>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>CBP</span>
							<el-input size="small" placeholder="Leave empty for 'MAX'" v-model="products.count.cbp"></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>UI</span>
							<el-input size="small" placeholder="Leave empty for 'MAX'" v-model="products.count.ui"></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>BI</span>
							<el-input size="small" placeholder="Leave empty for 'MAX'" v-model="products.count.bi"></el-input>
						</el-col>
					</el-row>
				</el-form-item> -->
				<el-form-item v-if="hidden && products.type != '' && products.productName.toLowerCase() == 'whatsapp conversation'" label="National Prefix Limit" :label-width="formLabelWidth">
					<el-row>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>CBP Limit per Month</span>
							<el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'cbp')" size="small" placeholder="Leave empty for '0'" v-model="products.count.cbp" :disabled="products.type == 'notification_caping_plafon' ? false:true"></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>UI Limit per Month</span>
							<el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'ui')" size="small" placeholder="Leave empty for 'MAX'" v-model="products.count.ui" :disabled="products.type == 'notification_caping_plafon' ? false:true"></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>BI Limit per Month</span>
							<el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'bi')" size="small" placeholder="Leave empty for 'MAX'" v-model="products.count.bi" :disabled="products.type == 'notification_caping_plafon' ? false:true"></el-input>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item v-if="hidden && products.type != '' && products.productName.toLowerCase() == 'whatsapp conversation'" label="International Set Prefix Limit" :label-width="formLabelWidth">
					<el-row>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
							<span>CBP Limit per Month</span>
							<el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'intern')" size="small" placeholder="Leave empty for 0" v-model="products.count.international" :disabled="products.type != 'notification_caping_plafon' ? true:false"></el-input>
						</el-col>
					</el-row>
				</el-form-item>
				<!-- <el-form-item v-if="hidden && products.type == 'notification_caping_plafon'" label="Hybrid Type" :label-width="formLabelWidth">
						<el-radio-group v-model="radio_hybrid">
							<el-radio :label="1">Bundle Quota</el-radio>
							<el-radio :label="2">Plafon Quota</el-radio>
						</el-radio-group>
				</el-form-item> -->
				<!-- <el-form-item v-if="hidden" label="Reff Note" :label-width="formLabelWidth">
                    <el-input type="textarea" :rows="4" v-model="products.reff_note" placeholder="Insert note for updated product (Optional)"></el-input>
                </el-form-item> -->
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addProduct" :loading="loadingBtn">Create</el-button>
    			<el-button @click="dialogFormVisible=false">Cancel</el-button>
			</span>
		</el-dialog>

		<el-dialog :close-on-click-modal="false" title="New Product" :visible.sync="dialogFormAddNewProduct" @closed="clear()">
			<el-form :label-position="`left`" ref="form" :model="products" label-width="120px">
				<el-form-item label="Product Name" :label-width="formLabelWidth">
					<template>
						<el-select @change="handleChangeProductName" v-model="newProducts.name" placeholder="Select" style="width: 330px">
							<el-option
							v-for="item in nameOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>
				</el-form-item>
	
				<el-form-item label="Product Type" :label-width="formLabelWidth">
					<template>
						<el-select @change="handleChangeProductName" v-model="newProducts.type" placeholder="Select" style="width: 330px">
							<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</template>
				</el-form-item>
		
				<el-form-item label="Product SKU" :label-width="formLabelWidth">
					<el-input v-model="newProducts.sku"></el-input>
				</el-form-item>
	
				<el-form-item label="Product Alias Name" :label-width="formLabelWidth">
					<el-input v-model="newProducts.alias_name"></el-input>
				</el-form-item>
		
				<el-form-item label="Product Description" :label-width="formLabelWidth">
					<el-input rows="6" type="textarea" v-model="newProducts.description"></el-input>
				</el-form-item>
	
				<el-form-item label="Product Plan" :label-width="formLabelWidth">
					<el-input v-model="newProducts.plan" disabled></el-input>
				</el-form-item>
	
				<el-form-item label="Product Price" :label-width="formLabelWidth">
					<el-input @keypress.native="numberOnly" v-model="newProducts.price"></el-input>
				</el-form-item>
	
				<el-form-item label="PPN (%)" :label-width="formLabelWidth">
					<el-input @keypress.native="numberOnly" @paste.native="paste($event, index, 'tax')" v-model="newProducts.ppn"></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addNewProduct" :loading="btnLoadingNewProduct">Create</el-button>
    			<el-button @click="dialogFormAddNewProduct=false">Cancel</el-button>
			</span>
		</el-dialog>

		<el-card>
			<div slot="header" class="clearfix mb-10">
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
					<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
						Total Product : <br>
						<span style="font-size:32px;">{{ (total) }}</span>
						<!-- <span style="font-size:32px;" v-else><i class="mdi mdi-message-text-outline fl-l"></i> -</span> -->
					</el-card>
				</el-col>
				<!-- <strong style="font-size:24px;">Total : {{total}}</strong> -->
				<el-button type="primary" @click="dialogFormVisible=true" style="float:left;" class="mt-20 mb-20">+ Add Product</el-button>
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
				<el-pagination
					background
					prev-text="Prev"
					next-text="Next"
					layout="prev, pager, next"
					:page-size="10"
					@current-change="paginateProduct"
					:current-page="currentPage"
					:total="parseInt(total)">
				</el-pagination>
				</el-col>

			</div>
			
			<template>
				<el-table :data="product" style="width: 100%" v-loading="loadingProduct" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
					<el-table-column prop="type" label="Product SKU" width="200" fixed="left">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.productSKU }}</p>
						</template>
					</el-table-column>

					<el-table-column prop="createdAt" label="Created At" width="200">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatDate(props.row.createdAt, "DD/MM/YY HH:mm:ss") }}</p>
						</template>
					</el-table-column>

					<el-table-column prop="productName" label="Product Name" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.productName }}</p>
						</template>
					</el-table-column>

					<el-table-column prop="price" label="Product Price" width="250">
						<template slot-scope="props">
							<p v-if="props.row.productName.toLowerCase() =='whatsapp conversation' || props.row.productName.toLowerCase() =='omnichannel' || props.row.productName.toLowerCase() =='maintenance' " style="font-weight:bold;">{{ formatPrice(props.row.minPrice) }}</p>
							<p v-else style="font-weight:bold;">{{ formatPrice(props.row.price) }}</p>
						</template>
					</el-table-column>

					<el-table-column prop="type" label="Product Type" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ capitalizeFirstLetter(props.row.type) }}</p>
						</template>
					</el-table-column>
					
					<el-table-column fixed="right" label="#" width="190">
						<template slot-scope="scope">
							<el-button @click="detailProduct(scope.row._id)" type="primary" size="small">
								<i class="mdi mdi-eye"></i> 
								<!-- Detail -->
							</el-button>
							<!-- <el-button @click="dialogFormVisibleDelete=true , scope.row._id" type="danger" size="small">Delete</el-button> -->
							<el-button @click="deleteProduct(scope.row._id)" type="danger" size="small" :loading="loadingBtnDelete">
								<i class="mdi mdi-delete-forever"></i> 
								<!-- Delete -->
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- <el-dialog title="Delete Product" :visible.sync="dialogFormVisibleDelete">
					<el-form>
						<el-form-item>
							<span>Are you sure ?</span>
						</el-form-item>
						<el-form-item>
							<el-button @click="deleteProduct" type="danger" size="small">Delete</el-button>
							<el-button>No</el-button>
						</el-form-item>
					</el-form>
				</el-dialog> -->
			</template>
		</el-card>
		<el-card class="mt-10">
			<el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateProduct"
				:current-page="currentPage"
				:total="parseInt(total)">
			</el-pagination>
		</el-card>
		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
// import moment from 'moment-timezone'
import CountryFlag from 'vue-country-flag'
const moment = require('moment')

export default {
	name: 'Products',
	data () {
		return {
			radio_hybrid: 0,
			discountType:[
				{
				value: 'percentage',
				label: 'Percentage'
				}, {
					value: 'currency',
					label: 'Currency'
				}
			],
			discount: false,
			hidden: false,
			countries: [],
			totalCountries: 0,
			nameOptions: [{
				value: 'Whatsapp Template Based',
				label: 'Whatsapp Template Based'
			}, {
				value: 'Whatsapp Conversation',
				label: 'Whatsapp Conversation'
			},{
				value: 'Maintenance',
				label: 'Maintenance'
			},
			{
				value: 'Omnichannel',
				label: 'Omnichannel'
			},
			 {
				value: 'Whatsapp Notification',
				label: 'Whatsapp Notification'
			},{
				
				value: 'Whatsapp Traffic Outbond',
				label: 'Whatsapp Traffic Outbond'
			},
			 {
				value: 'Shorten URL',
				label: 'Shorten URL'
			}, {
				value: 'Telegram Integration',
				label: 'Telegram Integration'
			}, {
				value: 'Line Integration',
				label: 'Line Integration'
			}],
			options: [{
				value: 'notification',
				label: 'Notification'
			}, {
				value: 'notification_caping',
				label: 'Notification Caping'
			}, {
				value: 'notification_caping_plafon',
				label: 'Notification Caping Plafon'
			},{
				value: 'notification_prepaid',
				label: 'Notification Prepaid'
			}, {
				value: 'subscribe',
				label: 'Subscribe'
			}, {
				value: 'traffic',
				label: 'Traffic'
			}, {
				value: 'traffic_tier',
				label: 'Traffic Tier'
			}, {
				value: 'shorten',
				label: 'Shorten URL'
			}, {
				value: 'telegram',
				label: 'Telegram'
			}, {
				value: 'line',
				label: 'Line'
			}],
			options3: [
				{
					value: 'wtb_hybrid',
					label: 'Hybrid Payment Method'
				}
			],
			options2:[],
			value: '',
			dialogTableVisible: false,
			dialogFormVisible: false,
			dialogFormVisibleUpdate: false,
			dialogFormVisibleDelete: false,
			dialogFormAddNewProduct: false,
			product: [],
			products: {
				allowedUser: "-",
				allowedPrefix: [],
				prefix: [],
				productName: "",
				productSKU: "",
				description: "",
				type: "",
				plan: "Monthly",
				monthly_fee: 0,
				price: "",
				minPrice: "",
				tax: 11,
				count: "0",
				aliasName: "",
				tier: [],
				max_account: 0,
				whitelistHsm: [],
				monthly_free_count: 0,
				service: {
					type: "Percentage",
					fee: 10
				},
				count: '',
				hybrid_type: '',
				reff_note: ''
			},
			newProducts: {
				name: '',
				type: '',
				sku: '',
				alias_name: '',
				description: '',
				plan: 'Monthly',
				price: '',
				ppn: ''
			},
			total:'',
			currentPage: 1,
			loadingProduct:true,
			formLabelWidth: '180px',
			loadingBtn:false,
			loadingBtnDelete:false,
			loadingTemplate: false,
			hsm: [],
			totalHsm: '',
			searchTemplate: '',
			btnLoadingNewProduct: false
		}
	},
	components: {
        CountryFlag
    },
	methods: {
		handleClose(tag){

		},
		totalAfterDisc(type, val, disc = 0){
			if (type == 'percentage') {
				return val - (val * disc / 100)
			}
			else if (type == 'currency') {
				return val - disc
			}
			else {
				return val
			}
		},
		async getAllHSM(page = 1){
			this.loadingTemplate = true
			var self = this
			await api({
				url:config.baseApi + 'get_hsm',
				params: {
					page: page,
					search: this.searchTemplate
				},
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.hsm = _.remove(response.data.data.list, (v) => { return _.isEmpty(v.message) == false })
					console.log('hsm',this.hsm)
					this.totalHsm = response.data.data.total
				}
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		numberOnly(e) {
			// console.log(e);
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, index, field) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }
			if (field == 'cbp_disc' || field == 'ui_disc' || field == 'bi_disc') {
				this.products.prefix[index].discount[field.replace('_disc','')].value = FilteredChars
			}
			else if(field == 'cbp' || field == 'ui' || field == 'bi'){
				let name = field == 'cbp' ? '': `_${field}`
				this.products[`monthly_free_count${name}`]
			}
			else if(field == 'intern'){
				this.products.monthly_free_count_international = FilteredChars
			}
			else if(field == 'tax'){
				this.products.count.tax = FilteredChars
			}
			else if(field == 'service'){
				this.products.service.fee = FilteredChars
			}
			else if(field == 'monthly'){
				this.products.monthly_fee = FilteredChars
			}
			else if(field == 'count'){
				this.products.max_account = FilteredChars
			}
			else {
				this.products.tier[index][field] = FilteredChars

			}
        },
		buttonAddTier(){
            if(this.products.tier.length > 0){
                let lastPosition = this.products.tier.length - 1
                let lastTier = this.products.tier[lastPosition]
                if(Number.isInteger(parseInt(lastTier.to))){
                    this.products.tier.push({ from: parseInt(lastTier.to) + 1, to: "-", price: parseInt(lastTier.price) + 1000000 })
                } else{
                    this.$message.warning({
                        message: 'Last row of tier is not valid'
                    })
                }
            } else{
                this.products.tier.push({ from: 1, to: "-", price: 1000000 })
            }
        },
		handleChangeProductType(value){
			if (this.products.productName.toLowerCase() == "whatsapp conversation") {
				switch (value) {
					case 'notification':
						this.products.count = {
							cbp: '0',
							ui: 'MAX',
							bi: 'MAX',
							international: 'MAX'
						}
						break;
					case 'notification_caping':
						this.products.count = {
							cbp: '0',
							ui: '0',
							bi: '0',
							international: '0'
						}
						break;
					case 'notification_caping_plafon':
						this.products.count = {
							cbp: '0',
							ui: '0',
							bi: '0',
							international: '0'
						}
						break;
				}
			}
		},
		handleChangePrefix(val){
			let found = null
			this.products.prefix = []
			this.discount = false
			if (val.length > 0) {
				val.forEach(el => {
					found = this.countries.find(element => element.prefixCode == el.prefixCode);
					if (found) {
						this.products.prefix.push({
							code_prefix: `+${found.prefixCode}`,
							price : {
								cbp : found.price_cbp,
								bi: found.price_bi,
								ui: found.price_ui
							},
							discount : found.prefixCode == '62' ? {cbp:{type:'', value: 0},ui:{type:'', value: 0},bi:{type:'', value: 0}}: false
						})

						if (found.prefixCode == '62') {
							this.discount = true
						}
					}
				})
			}
		},
		handleChangeProductName(value){
			this.options2 = []
			this.products.type = ""
			this.products.service = {
					type: 'Percentage',
					fee: 0
			}
			if (value == 'Whatsapp Conversation') {
			this.options.forEach(el => {
					switch (el.value) {
						case "notification":
							el.label = 'CBP Invoice'
							this.options2.push(el)
							break;
						case "notification_caping":
							el.label = 'CBP Caping'
							this.options2.push(el)
							break;
						case "notification_caping_plafon":
							el.label = 'CBP Hybrid'
							this.options2.push(el)
							break;
					}
				})
				this.products.count = {
					cbp: '',
					ui: '',
					bi: '',
					international: ''
				}

				if (this.countries.length > 0) {
					// this.products.allowedPrefix = this.countries.map(el => el.prefixCode)
					let allowedPrefix = this.countries.filter(el => el.prefixCode == '62')
					this.handleChangePrefix(allowedPrefix)	
				}
				

				this.hidden = true
			}
			else if (value == 'Maintenance') {
				this.options2.push({
					label: 'Chatbot',
					value: 'chatbot'
				})

				this.products.count = {
					cbp: '0',
					ui: '0',
					bi: '0',
					international: '0'
				}

				this.products.service = {
					type: 'Currency',
					fee: 0
				}
				

				this.hidden = true
			}
			else if (value == 'Omnichannel') {
				// this.options2.push({
				// 	label: 'Telegram',
				// 	value: 'telegram'
				// })

				this.options2 = [{
					label: 'Telegram',
					value: 'telegram'
				},{
					label: 'Line',
					value: 'line'
				},{
					label: 'Facebook',
					value: 'facebook'
				},
				{
					label: 'Instagram',
					value: 'instagram'
				},
				{
					label: 'Live Chat',
					value: 'livechat'
				}]

				this.products.count = {
					cbp: '0',
					ui: '0',
					bi: '0',
					international: '0'
				}

				this.products.service = {
					type: 'Currency',
					fee: 0
				}

				this.hidden = true
			}
			else {
				this.options.forEach(el => {
					switch (el.value) {
						case "notification":
							el.label = 'Notification'
							break;
						case "notification_caping":
							el.label = 'Notification Caping'
							break;
						case "notification_caping_plafon":
							el.label = 'Notification Caping Plafon'
							break;
					}
				})
				this.products.count = ''

				
				this.hidden = false
			}
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatCurr() {
	        this.products.price = this.currencyFormat(this.products.price)
	      },
		handleClick() {
			// console.log('click');
		},
		onSubmit() {
			// console.log('click');
		},
		formatDate(val, format){
            return moment(val).format(format)
		},
		formatPrice(value) {
            // let val = (value/1).toFixed(2).replace('.', ',')
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") value = 0
			return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
		async Product(page = 1){
			this.loadingProduct = true
            await api({
                url: config.baseApi + "product?page="+page,
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					this.product = res.data.data.product
					this.total = res.data.data.total
				}
            })
            .catch(err => {

            })
            this.loadingProduct = false
		},
		async Prefix(page = 1){
			this.loadingProduct = true
            await api({
                url: config.baseApi + "prefix?page="+page +`&all=${true}`,
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					this.countries = res.data.data.prefix
					this.totalCountries = res.data.data.total

					if (this.countries.length > 0) {
                        this.countries = this.countries.filter(el => el.status == 'true')
                    }
				}
            })
            .catch(err => {

            })
            this.loadingProduct = false
		},
		async addProduct(){
			this.loadingBtn = true
			// var [] = this.products
			if(!this.products.productName || !this.products.type || this.products.tax == '' || !this.products.productSKU){
				this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				this.loadingBtn = false
				return
			}

			let data = {
					"allowedUser": this.products.allowedUser,
					"productName": this.products.productName,
					"productSKU": this.products.productSKU,
					"description": this.products.description,
					// "createdAt": this.products.createdAt,
					// "updatedAt": this.products.updatedAt,
					"type": this.products.type.toLowerCase(),
					"plan": this.products.plan.toLowerCase(),
					"price": this.products.price || 0,
					"minPrice": this.products.minPrice,
					"tax": this.products.tax,
					"count": this.products.count,
					"aliasName": this.products.aliasName,
					"monthly_free_count": parseInt(this.products.monthly_free_count),
					"max_account": parseInt(this.products.max_account) || 10,
					tier: this.products.tier.length > 0 ? this.products.tier : undefined,
					whitelistHsm: this.products.whitelistHsm.length > 0 ? this.products.whitelistHsm : undefined,
				}

			if (this.products.productName == 'Whatsapp Conversation' || this.products.productName == 'Maintenance' || this.products.productName == 'Omnichannel') {
				if(this.products.prefix.length == 0 && this.products.productName == 'Whatsapp Conversation'){
					this.$message.error({
						showClose: false,
						message: 'Prefix code not found, please add prefix on menu prefix first!'
					});
					this.loadingBtn = false
					return
				}
				if (this.products.prefix.length > 0) {
					console.log(this.products.prefix);
					this.products.prefix.forEach(el => {
						el.discount.cbp ={type:'',value:Number(el.discount.cbp) || 0}
						el.discount.ui = {type:'',value:Number(el.discount.ui) || 0}
						el.discount.bi = {type:'',value:Number(el.discount.bi) || 0}
					})
				}

				if (this.products.allowedPrefix.length > 0) {
					this.products.allowedPrefix.forEach(ele => {
						ele = `+${ele}`
					});
				}

				delete data["count"]

				data["minPrice"] = this.products.monthly_fee.toString() || this.products.minPrice
				data["monthly_free_count"] = parseInt(this.products.count.cbp)|| 0
				data["monthly_free_count_ui"] = parseInt(this.products.count.ui) || 0
				data["monthly_free_count_bi"] = parseInt(this.products.count.bi) || 0
				data["monthly_free_count_international"] = parseInt(this.products.count.international) || 0
				data["allowedPrefix"] = this.products.allowedPrefix
				data["prefix"] = this.products.prefix
				this.products.service.type = this.products.service.type.toLowerCase()
				data["product_service"] = this.products.service
				
				if (this.products.type.toLowerCase() == 'notification_caping_plafon') {
					// this.products.hybrid_type = this.radio_hybrid == 2 ? 'plafon_quota' : 'bundle_quota'
					switch (this.radio_hybrid) {
						case 1:
							this.products.hybrid_type = 'bundle_quota'
							break;
					
						case 2:
							this.products.hybrid_type = 'plafon_quota'
							break;
					}
				}

				data["hybrid_type"] = this.products.hybrid_type
				data["reff_note"] = this.products.reff_note

				switch (this.products.type) {
					case 'notification':
						delete data["monthly_free_count_ui"]
						delete data["monthly_free_count_bi"]
						delete data["hybrid_type"]
						break;
					case 'notification_caping':
						delete data["monthly_free_count_international"]
						delete data["hybrid_type"]
						break;
				}

				// if (this.products.count.cbp == 'MAX') {
				// 	data["disable_quota_cbp"] = true
				// }

				if (this.products.count.ui == 'MAX' || this.products.count.ui.trim() == '') {
					data["is_ui_max"] = true
				}

				if (this.products.count.bi == 'MAX' || this.products.count.bi.trim() == '') {
					data["is_bi_max"] = true
				}

			}

			await api({
				url: config.baseApi + "product",
				method: 'post',
				data: data
			}).then(res => {
				if(res.data.ec != 200){
					if(res.data.message == "SKU_used"){
						this.$swal(this.$t('warning'), this.$t('product.sku_used'), "warning")
					} else{
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
					}
					// console.log('fatal error')
				} else {
					this.$message({
						type: 'success',
						message: 'Add Product Success'
					});
					this.clear()
					// this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// console.log("res",res.data)
					this.dialogFormVisible = false
					this.Product()
				}
			}).catch(err => {
				console.log("Error",err)
			})
			this.loadingBtn = false
		},
		async addNewProduct(){
			let data = {
				productName: this.newProducts.name,
				type: this.newProducts.type,
				productSKU: this.newProducts.sku,
				aliasName: this.newProducts.alias_name,
				description: this.newProducts.description,
				plan: this.newProducts.plan,
				price: this.newProducts.price,
				tax: this.newProducts.ppn
			}

			this.btnLoadingNewProduct = false;
			await api({
				url: config.baseApi + "product",
				method: 'post',
				data: data
			}).then(res => {
				if(res.data.ec != 200){
					if(res.data.message == "SKU_used"){
						this.$swal(this.$t('warning'), this.$t('product.sku_used'), "warning")
					} else{
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
					}
				} else {
					this.$message({
						type: 'success',
						message: 'Add Product Success'
					});
					this.clearNewProduct()
					this.dialogFormAddNewProduct = false
					this.Product()
				}
			}).catch(err => {
				console.log("Error",err)
			})
			this.btnLoadingNewProduct = false
		},

		async paginateProduct(page){
			this.currentPage = page
			await this.Product(this.currentPage)
		},

		async detailProduct(param){
			this.$router.push('products/' + param)
		},

		async updatedProduct(){
            this.loadingBtn = true
            let productID = this.$route.params.products
			await api({
				url: config.baseApi + 'product/' + productID,
				method: 'patch',
				data: {
					"allowedUser": this.product.allowedUser,
					"productName": this.product.productName,
					"productSKU": this.product.productSKU,
					"description": this.product.description,
					"createdAt": this.product.createdAt,
					"updatedAt": this.product.updatedAt,
					"type": this.value || this.product.type,
					"plan": this.product.plan,
					"price": this.product.price,
					"minPrice": this.product.minPrice,
					"tax": this.product.tax,
					"count": this.product.count,
					"aliasName": this.product.aliasName
				}
			}).then(res => {
				if(res.data.ec != 200){
                    // console.log('Update sukses')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					// console.log('fatal error')
					this.dialogFormVisible = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success")
					// console.log("res",res.data)
					this.dialogFormVisible = false
					this.Product()
				}
			}).catch(err => {
				// console.log("Error",err)
            })
            this.loadingBtn=false
		},
		
		async deleteProduct(productId){
			this.loadingProduct = true
			this.loadingBtnDelete = true
			this.$confirm('This will permanently delete the product. Continue?', 'Warning', {
			confirmButtonText: 'OK',
			cancelButtonText: 'Cancel',
			type: 'warning',
			center: true
			}).then(() => {
				this.loadingBtnDelete = true
				api({
					url: config.baseApi + 'product/delete/' + productId,
					method: 'get',
					params:{
						productId:this.productId
					}
				}).then(res => {
					if(res.data.ec != 200){
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
						this.dialogFormVisible = false
					} else {
						// 
						this.$message({
							type: 'success',
							message: 'Delete completed'
						});
						this.clear()
						this.dialogFormVisible = false
						this.Product()
					}
				}).catch(err => {
					// console.log("Error",err)
				})
				this.loadingBtnDelete = false
			}).catch(() => {
				this.$message({
					type: 'info',
					message: 'Delete canceled'
				});
			});
			
			this.loadingBtnDelete = false
			this.loadingProduct = false
		},

		clear(){
			this.products = {
				allowedUser: "-",
				allowedPrefix: [],
				prefix: [],
				productName: "",
				productSKU: "",
				description: "",
				createdAt: "",
				updatedAt: "",
				type: "",
				plan: "Monthly",
				monthly_fee: 0,
				price: "",
				minPrice: "",
				tax: 10,
				count: "0",
				aliasName: "",
				tier: [],
				whitelistHsm: [],
				monthly_free_count: 0,
				max_account: 0,
				service: {
					type: "Percentage",
					fee: 10
				},
				count: '',
				hybrid_type: '',
				reff_note: ''
			}
			this.hidden = false
			this.discount = false
			// this.products.productName = ''
			// this.products.productSKU = ''
			// this.products.description = ''
			// this.products.monthly = ''
			// this.products.type = ''
			// this.products.price = ''
			// this.products.minPrice = ''
			// this.products.tax = ''
			// this.products.count = ''
			// this.products.aliasName = ''
		},

		clearNewProduct() {
			this.newProducts = {
				name: '',
				type: '',
				sku: '',
				alias_name: '',
				description: '',
				plan: '',
				price: '',
				ppn: ''
			}
		}
	},
	async mounted(){
		await this.Product()
		await this.Prefix()
		await this.getAllHSM()
	}
}
</script>
<style>
.swal2-container {
  	z-index: 10000;
}
</style>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>